export default __webpack_public_path__ + "static/media/paper-machine.8f8a7aa5.png";